import React, { useState } from "react";
import {
  Box,
  Heading,
  Text,
  Flex,
  Link,
  Icon,
  SimpleGrid,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  FormHelperText,
  useToast,
  VStack,
  HStack,
  useBreakpointValue, // Para determinar si es móvil
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";
import Slider from "react-slick"; // Importar Slider

import image1 from "../../assets/images/pablo.png";
import image2 from "../../assets/images/Alberto.jpeg";
import image3 from "../../assets/images/Sergio.jpg";
import image5 from "../../assets/images/Victor.jpg";
import image7 from "../../assets/images/Manuel.jpeg";

import GradientButton from "../buttons/GradientButton";

const TeamSection: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formValues, setFormValues] = useState({
    name: "",
    surname: "",
    email: "",
    linkedin: "",
    resumeUrl: "",
  });
  const toast = useToast();

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const { name, surname, email, resumeUrl } = formValues;
      if (!name || !surname || !email || !resumeUrl) {
        toast({
          title: "Error",
          description: "Por favor, completa todos los campos obligatorios.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // Simulación de una solicitud de API
      toast({
        title: "Información enviada.",
        description:
          "Gracias por tu interés. Nos pondremos en contacto contigo pronto.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      onClose();
    } catch (error) {
      toast({
        title: "Error.",
        description: "Hubo un problema al enviar tu información.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const teamMembers = [
    {
      name: "Manuel Escudero",
      position: "CEO",
      imageUrl: image7,
      linkedin:
        "https://www.linkedin.com/in/manuel-escudero-3426461bb?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
      name: "Sergio Serrano",
      position: "CMO",
      imageUrl: image3,
      linkedin: "https://www.linkedin.com/in/sergioserranogonzalez/",
    },
    {
      name: "Pablo Pérez Sánchez",
      position: "Colaborador",
      imageUrl: image1,
      linkedin: "https://www.linkedin.com/in/pablo-perez-sanchez-financeworld",
    },

    {
      name: "Alberto Valdes",
      position: "Embajador Zona Central de Mexico",
      imageUrl: image2,
      linkedin: "https://www.linkedin.com/in/arqalbertovaldes/",
    },
    
    {
      name: "Victor Pérez",
      position: "CTO - Embajador de Andorra",
      imageUrl: image5,
      linkedin: "https://ad.linkedin.com/in/victor-perez-1431b2242/es",
    },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
        },
      },
    ],
  };

  // Verifica si es desktop (lg = 992px+) para mostrar grid de 5 columnas
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  return (
    <Box maxW="1200px" mx="auto" py={10} px={4} textAlign="center">
      <Heading as="h2" fontSize="5xl" mb={20} color="primary.600">
        Nuestro Equipo
      </Heading>

      {/* Mostrar Grid de 5 columnas en desktop, Slider en tablet/móvil */}
      {isDesktop ? (
        <SimpleGrid columns={5} spacing={6}>
          {teamMembers.map((member, index) => (
            <Box key={index} p={4} textAlign="center">
              <Box
                width="full"
                maxWidth="220px"
                height="220px"
                borderRadius="md"
                overflow="hidden"
                mb={4}
                mx="auto"
                border="1px solid"
                borderColor="gray.200"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <img
                  src={member.imageUrl}
                  alt={member.name}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Box>
              <Flex direction="column" alignItems="center">
                <Heading as="h3" fontSize="md" mb={2}>
                  {member.name}
                </Heading>
                <Link href={member.linkedin} isExternal>
                  <Icon as={FaLinkedin} boxSize={5} color="primary.500" />
                </Link>
                <Text fontSize="xs" color="gray.600">
                  {member.position}
                </Text>
              </Flex>
            </Box>
          ))}
        </SimpleGrid>
      ) : (
        <Box px={4}>
          <Slider {...sliderSettings}>
            {teamMembers.map((member, index) => (
              <Box key={index} px={2}>
                <Box p={4} textAlign="center">
                  <Box
                    width="full"
                    maxWidth="300px"
                    height="300px"
                    borderRadius="md"
                    overflow="hidden"
                    mb={4}
                    mx="auto"
                    border="1px solid"
                    borderColor="gray.200"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <img
                      src={member.imageUrl}
                      alt={member.name}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </Box>
                  <Flex direction="column" alignItems="center">
                    <Heading as="h3" fontSize="lg" mb={2}>
                      {member.name}
                    </Heading>
                    <Link href={member.linkedin} isExternal>
                      <Icon as={FaLinkedin} boxSize={5} color="primary.500" />
                    </Link>
                    <Text fontSize="sm" color="gray.600">
                      {member.position}
                    </Text>
                  </Flex>
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>
      )}

      <Box mt={12} textAlign="center">
        <Heading as="h2" fontSize="2xl" mb={4}>
          <strong>Únete a nuestro equipo</strong>
        </Heading>
        <Text fontSize="lg" mb={6}>
          Si te apasiona la tecnología y ayudar a la gente, este es tu sitio.
        </Text>
        <HStack spacing={4} justify="center">
          <GradientButton onClick={onOpen}  gradientColor1="#0ef1fa"
              gradientColor2="#0b4d78">
            Solicitar Información
          </GradientButton>
          
        </HStack>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent bg="gray.800" color="white" borderRadius="md">
          <ModalHeader fontSize="2xl" fontWeight="bold" textAlign="center">
            Solicita Información
          </ModalHeader>
          <ModalBody>
            <VStack spacing={4}>
              <FormControl id="name" isRequired>
                <FormLabel>Nombre</FormLabel>
                <Input
                  name="name"
                  value={formValues.name}
                  onChange={handleInputChange}
                  placeholder="Nombre"
                  bg="gray.700"
                  borderColor="gray.600"
                  _hover={{ borderColor: "gray.500" }}
                  focusBorderColor="blue.500"
                />
              </FormControl>
              <FormControl id="surname" isRequired>
                <FormLabel>Apellidos</FormLabel>
                <Input
                  name="surname"
                  value={formValues.surname}
                  onChange={handleInputChange}
                  placeholder="Apellidos"
                  bg="gray.700"
                  borderColor="gray.600"
                  _hover={{ borderColor: "gray.500" }}
                  focusBorderColor="blue.500"
                />
              </FormControl>
              <FormControl id="email" isRequired>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  name="email"
                  value={formValues.email}
                  onChange={handleInputChange}
                  placeholder="Email"
                  bg="gray.700"
                  borderColor="gray.600"
                  _hover={{ borderColor: "gray.500" }}
                  focusBorderColor="blue.500"
                />
              </FormControl>
              <FormControl id="linkedin">
                <FormLabel>LinkedIn</FormLabel>
                <Input
                  name="linkedin"
                  value={formValues.linkedin}
                  onChange={handleInputChange}
                  placeholder="LinkedIn"
                  bg="gray.700"
                  borderColor="gray.600"
                  _hover={{ borderColor: "gray.500" }}
                  focusBorderColor="blue.500"
                />
              </FormControl>
              <FormControl id="resumeUrl" isRequired>
                <FormLabel>URL del Currículum</FormLabel>
                <Input
                  name="resumeUrl"
                  value={formValues.resumeUrl}
                  onChange={handleInputChange}
                  placeholder="Enlace al currículum"
                  bg="gray.700"
                  borderColor="gray.600"
                  _hover={{ borderColor: "gray.500" }}
                  focusBorderColor="blue.500"
                />
                <FormHelperText>
                  Proporciona un enlace a tu currículum en formato PDF o DOC.
                </FormHelperText>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter justifyContent="space-between">
            <Button variant="outline" colorScheme="red" onClick={onClose}>
              Cerrar
            </Button>
            <GradientButton onClick={handleSubmit}  gradientColor1="#0ef1fa"
              gradientColor2="#0b4d78">Enviar</GradientButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TeamSection;
